import { render, staticRenderFns } from "./nonMerStep2.vue?vue&type=template&id=4cd57062&scoped=true&"
import script from "./nonMerStep2.vue?vue&type=script&lang=js&"
export * from "./nonMerStep2.vue?vue&type=script&lang=js&"
import style0 from "./nonMerStep2.vue?vue&type=style&index=0&id=4cd57062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd57062",
  null
  
)

export default component.exports